module.exports = __webpack_public_path__ + "static/media/eminence-asakusa-6.d526262e.jpg";